const PlatformType = {
    "WEB": "WEB",
    "ANDROID": "ANDROID",
    "IOS": "IOS"
}

export default PlatformType;


// WEBPACK FOOTER //
// ./src/enums/PlatformType.js